import { Space, Tooltip, Dropdown, message } from "antd";
import React from "react";
import { BrokenLinkIcon, EditIcon, EyeIcon, EyeSlashIcon, LinkIcon, OpenIcon } from "../../admin/Icons";
import Overlay from "../Overlay";
import { blue_color, green_color, grey_color, orange_color, purple_color, red_color, trimTrailingChar, tt_menu_draft, tt_menu_link, tt_menu_unlisted, tt_menu_visible } from "../../utils/Utils";
import MenuEdit from "../../admin/Menu/MenuEdit";
import { apiCall } from "../../utils/Api";

export default function PageRow(props) {

    const { children = [], page = {}, setPage = () => { }, menus = [], setMenus = () => { }, setToOpenPage = () => { } } = props;

    const {
        can_delete = false,
        id = 0,
        is_v1 = true,
        name = "",
        new_tab = false,
        order = 0,
        parent_id = null,
        path = "",
        type = "custom",
        url = null,
        v1_page_id = 0,
        visibility = "visible",
    } = page;



    const openLink = () => {

        let link = "";
        if (url) {
            if (url.substr(0, 4) === "http") {
                link = url;
            } else {
                link = trimTrailingChar(window.sitesettings.url, "/") + url;
            }
        }

        if (link) { window.open(link, "_blank"); return; }

        if (path) {
            link = trimTrailingChar(window.sitesettings.url, "/") + path;
        }

        if (link) { window.open(link, "_blank"); return; }

    }

    const drawLink = () => {

        return (
            <div style={{ "position": "relative", "top": "3px" }} >

                {(children.length == 0 && <Tooltip title={tt_menu_link} >
                    <LinkIcon onClick={() => openLink()} style={{ "color": blue_color }} />
                </Tooltip>)}
                {(children.length > 0 && <BrokenLinkIcon style={{ "color": grey_color }} />)}
                
            </div>
        )
    }

    const updateMenuItem = (_val) => {

        let _update = { ...page }
        _update.visibility = _val;
        _update.menu_id = _update.id;
        if (!_update.parent_id) {
            delete _update.parent_id;
        }

        if (!can_delete && _val !== "hidden") {
            _update.name = name.replace(" (unlisted)", "")
        }

        if (!can_delete && _val === "hidden") {
            _update.name = name + " (unlisted)";
        }

        // ensure url is empty string if falsey or string null
        if (!_update.url || _update.url === "null") {
            _update.url = "";
        }

        apiCall("site_content/updateMenu", _update, (_status, _result) => {
            if (_status) {
                setMenus(_result);
            } else {
                message.error(_result.error);
            }
        })
    }

    let items = [

        { label: <div onClick={() => updateMenuItem("visible")} style={{ "color": "#3c8617", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#3c8617" }} />&nbsp; Visible</div>, key: 'visible' },
        { label: <div onClick={() => updateMenuItem("hidden")} style={{ "color": "#aa119d", "display": "flex", "alignItems": "center" }}><EyeIcon style={{ "color": "#aa119d" }} />&nbsp; Unlisted</div>, key: "hidden" }
    ];

    if (can_delete) {
        items.unshift({ label: <div onClick={() => updateMenuItem("test")} style={{ "color": "#e77e21", "display": "flex", "alignItems": "center" }}><EyeSlashIcon style={{ "color": "#e77e21" }} />&nbsp; Draft</div>, key: 'test' })
    }


    const drawVisibility = () => {

        let color;
        let tip = "";

        switch (visibility) {
            case "visible":
                color = green_color;
                tip = tt_menu_visible;
                break;
            case "test":
                color = orange_color;
                tip = tt_menu_draft;
                return <Dropdown trigger={['click']} menu={{ items }}><Tooltip title={tip}><EyeSlashIcon style={{ "color": color }} /></Tooltip></Dropdown>
            case "hidden":
                tip = tt_menu_unlisted
                color = purple_color
                break;
        }

        return (<Dropdown trigger={['click']} menu={{ items }}><Tooltip title={tip}><EyeIcon style={{ "color": color }} /></Tooltip></Dropdown>)

    }

    const drawTools = () => {
        return (
            <div onClick={(e) => e.stopPropagation()}>
                <Space>
                    {drawLink()}
                    {drawVisibility()}
                    <Overlay width={500} component={<MenuEdit setPage={setPage} setToOpenPage={setToOpenPage} setMenus={setMenus} menus={menus} page={page} />}>
                        <EditIcon style={{ "color": orange_color }} />
                    </Overlay>
                </Space>
            </div>
        )
    }

    return (
        <div key={id} className="float-flex">
            <div style={{ "color": (is_v1) ? "#888" : "inherit" }}>{name} {is_v1 && <small style={{ "fontSize": "8px", "color": "#c94646" }}>*</small>}</div>
            {drawTools()}
        </div>
    )
}